// Ending a sign-in on this browser (#523).
//
// The header shows a customer as signed in while "userid" is stored, and never
// looks at the token. So a sign-in the server will not renew must remove the
// stored keys, or the header keeps showing the customer's name after the
// session has expired. The language is kept: it is the visitor's, not the
// account's.
export const clearSignIn = () => {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key !== "language") localStorage.removeItem(key);
  }
};

// Signs out and goes to the home page, where the header opens the sign-in box.
export const endSignIn = (to = "/") => {
  clearSignIn();
  localStorage.setItem("needLogin", "true");
  window.location = to;
};
